import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getBanners(query) {
    return (await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `v2/banners${objectToQueryString(query)}`,
        authorization: process.env.LETS_TRADE_CLIENT_TOKEN,
    }));
}
export { getBanners };
